/* ========================================================
アナウンスメントバー表示の際にヘッダーが被るため修正
スクロールが開始されるとheaderにクラスの付け外しをして調整する
=========================================================*/

// ヘッダー初期化関数
function initializeHeader() {
  const header = document.getElementById('section-header');
  const announcementSection = document.getElementById('section-announcement');
  const HeaderWrapper = document.querySelector('.Header__Wrapper');

  if (!announcementSection) return;

  window.addEventListener('scroll', () => {
    header.classList.toggle('js-headerTop', window.scrollY < 20);
  });

  header.classList.add('js-headerTop');
  HeaderWrapper.classList.add('js-headerScroll');
}

// ドロップダウン初期化関数
function initializeDropdown() {
  const toggleDropdown = (element, isOpen) => {
    const dropdownMenu = element.nextElementSibling;
    dropdownMenu.setAttribute('aria-hidden', String(!isOpen));
    element.classList.toggle('is-expanded', isOpen);
    document.documentElement.classList.toggle('no-scroll', isOpen);
  };

  document.querySelectorAll('.js-category').forEach(category => {
    category.addEventListener('click', () => {
      const isExpanded = category.classList.contains('is-expanded');
      toggleDropdown(category, !isExpanded);
    });
  });

  document.querySelectorAll('.js-close').forEach(closeButton => {
    closeButton.addEventListener('click', () => {
      const dropdownMenu = closeButton.closest('.DropdownMenu');
      if (dropdownMenu) {
        toggleDropdown(dropdownMenu.previousElementSibling, false);
      }
    });
  });

  // aria-hidden属性の監視を設定
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
        const dropdownMenu = mutation.target;
        const ariaHidden = dropdownMenu.getAttribute('aria-hidden') === 'true';
        document.documentElement.classList.toggle('no-scroll', !ariaHidden);
      }
    });
  });

document.querySelectorAll('.DropdownMenu:not(#sidebar-cart)').forEach(dropdownMenu => {
  observer.observe(dropdownMenu, { attributes: true });
});
}

// ページロード時に初期化
window.addEventListener('DOMContentLoaded', () => {
  initializeHeader();
  initializeDropdown();
});